import * as S from './ErrorComponent.styled';
import { EmotionSad } from 'assets/icons';

const ErrorComponent = ({ style }) => {
  return (
    <S.Error style={style}>
      <EmotionSad />
      <span>No data received...</span>
      <span>Unable to receive data at this moment, try reloading the page.</span>
    </S.Error>
  );
};

export default ErrorComponent;
